import { render, staticRenderFns } from "./GiftcardDisplay.vue?vue&type=template&id=92989936"
import script from "./GiftcardDisplay.vue?vue&type=script&lang=js"
export * from "./GiftcardDisplay.vue?vue&type=script&lang=js"
import style0 from "./GiftcardDisplay.vue?vue&type=style&index=0&id=92989936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports